<bb-page-header [icon]="'upload'" [title]="'UPLOAD_TRANSCODE' | translate">

	<ul class="tabs">
		<li>
			<a [routerLink]="['/library/upload-transcode', 'upload']" routerLinkActive="active">
				<i class="fa fa-upload"></i> {{ 'UPLOAD' | translate }}
			</a>
		</li>
		<li>
			<a [routerLink]="['/library/upload-transcode', 'live-stream']" routerLinkActive="active">
				<i class="fa fa-feed"></i> {{ 'LIVE_STREAM' | translate }}
			</a>
		</li>
		<li>
			<a [routerLink]="['/library/upload-transcode', 'publication-import']" routerLinkActive="active">
				<i class="fa fa-level-down"></i> {{ 'IMPORT_FROM_PUBLICATION' | translate }}
			</a>
		</li>
	</ul>

</bb-page-header>

<div class="main-container">
	<div class="sub-container">
		<div class="body-column tab-container" cdkScrollable [ngSwitch]="activeTab">
			<!-- Different tabs for uploading -->
			<upload-transcode-upload [hidden]="activeTab !== 'upload'" [autoName]="autoName" [autoPublish]="autoPublish" [embargo]="embargo"></upload-transcode-upload>
			<upload-transcode-publication-import [hidden]="activeTab !== 'publication-import'" [path]="'/library/upload-transcode/publication-import'"></upload-transcode-publication-import>
			<upload-transcode-live [hidden]="activeTab !== 'live-stream'"></upload-transcode-live>
		</div>
	</div>
</div>
